export const spacing = {
    none: '0',
    tight: '.5rem',
    compact: '1rem',
    cozy: '3rem',
    comfortable: '5rem',
    outerspace: '8rem'
};
export const scrollMargin = {
    top: 72
};
//# sourceMappingURL=spacing.js.map